export enum ImportTypeEnum {
  location = 'location',
  equipment = 'equipment',
  recurrence = 'recurrence',
  maintenance = 'maintenance',
  product = 'product',
  service = 'service',
  location_service_provider = 'location_service_provider',
  group = 'group',
  user = 'user',
  archive_recurrence = 'archive_recurrence',
  archive_maintenance = 'archive_maintenance',
  cancel_maintenance = 'cancel_maintenance',
  sector = 'sector',
  environment = 'environment',
  storage = 'storage',
  product_type = 'product_type',
  warranty = 'warranty',
  storage_product = 'storage_product'
}

export const IMPORTS_WITH_FLAGS = [
  {
    importType: ImportTypeEnum.storage,
    flag: 'storage'
  },
  {
    importType: ImportTypeEnum.product_type,
    flag: 'storage'
  },
  {
    importType: ImportTypeEnum.warranty,
    flag: 'warranties'
  },
  {
    importType: ImportTypeEnum.storage_product,
    flag: 'importStorageProductFeatureFlag'
  }
];

export enum ImportStatusEnum {
  validation_pending = 'validation_pending',
  validation_queued = 'validation_queued',
  validation_in_progress = 'validation_in_progress',
  validation_success = 'validation_success',
  validation_error = 'validation_error',
  import_queued = 'import_queued',
  import_in_progress = 'import_in_progress',
  import_success = 'import_success',
  import_partial_success = 'import_partial_success',
  import_error = 'import_error'
}

export enum ImportOrderByInputEnum {
  createdAt_asc = 'createdAt_asc',
  createdAt_desc = 'createdAt_desc'
}
